import React from 'react';
import Header from '../../../header/header';
import Footer from '../../../footer/footer';


const Creche = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
<br></br>
<br></br>
        <div className="section-title">
          <h2>Les ateliers pour les crèches</h2>
          <br></br>
                    <br></br>
                     <div className="activites-list" >
  <br></br>

<div className="col-xs-12 col-md-6">
<img className="img-responsive" src="../img/version1/ateliers/creche/2.jpg" alt="Atelier floral crèche Chennevières-sur-Marne - création bouquet fleurs Delphia Paul fleuriste 94" />
<br></br><br></br></div>
<div className="col-xs-12 col-md-6">
 <p>
        Je propose des ateliers floraux spécialement conçus pour les enfants en crèche, de 22 mois à 3 ans. Ce sont des moments ludiques et sensoriels, pensés pour éveiller la curiosité, stimuler les sens (odorat, toucher, vue), développer la motricité fine et encourager les premiers gestes créatifs autour de la nature.
      </p>

      <p>
        Chaque atelier se déroule dans une ambiance douce et bienveillante, adaptée au rythme des tout-petits, avec des matériaux naturels, non dangereux, ainsi que des fleurs fraîches ou séchées soigneusement sélectionnées.
      </p>
<br></br>

      <h4>Programme des ateliers floraux pour enfants</h4>
<br></br>

      <ul className='libouquets'>
        <li><strong>Octobre</strong> : Mon petit pot de citrouille — découverte des formes et des couleurs d’automne</li>
        <li><strong>Décembre</strong> : Mini centre de table de Noël — atelier de partage et d’observation</li>
        <li><strong>Février</strong> : Petites mains, grandes fleurs — plantation de bulbes</li>
        <li><strong>Avril</strong> : Le jardin de l’amitié — plantation de petites fleurs et légumes</li>
        <li><strong>Juin</strong> : Fête de la nature — fleurs, feuillages et jeux sensoriels, création d’un bouquet</li>
      </ul>
<br></br>

      <h4>Organisation des ateliers</h4>
<br></br>

      <p>
        Les ateliers durent environ 30 à 45 minutes et se déroulent en petits groupes afin de respecter le rythme de chaque enfant (6 à 10 enfants maximum).
      </p>
<br></br>

    
</div>
        </div>
        
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
export default Creche;